exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-4f5a1779] {\n  padding-bottom: 6px;\n  color: #b5b5b5;\n}\n.config-item[data-v-4f5a1779] {\n  background-color: #fff;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n.config-item .delete[data-v-4f5a1779] {\n  position: absolute;\n  top: -4px;\n  right: -12px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background-color: rgba(255, 2, 0, 0.7);\n  color: #fff;\n  font-size: 14px;\n  text-align: center;\n  line-height: 22px;\n  cursor: pointer;\n  opacity: 1;\n}\n.teacher-info[data-v-4f5a1779] {\n  list-style-type: none;\n  padding-left: 0;\n}\n", ""]);

// exports
